import * as toast from 'utils/toast';
import { NO_INTERNET_CONNECTION_ERROR_MESSAGE } from '../constants/appConstants';

/**
 * Runs a callback only when the browser is online.
 *
 * @param callback - Callback to execute when online.
 * @returns Toast response when offline, otherwise callback result.
 */
export const handleUserOfflineMode = (callback = () => true) => {
  const isOnline = window.navigator.onLine;

  if (!isOnline) {
    return toast.error({
      title: 'Error',
      message: NO_INTERNET_CONNECTION_ERROR_MESSAGE,
      className: '',
    });
  }

  return callback();
};
